import React, { useState, useEffect, useContext } from 'react';
import './accounts-modal.scss';
import { default as t } from '../../../../utils/i18n';
import queryString from 'query-string';
import { UserContext, ToasterContext } from '../../../../context';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import { OnboardedAccounts, OtherBMAccounts, UsersList } from '../../molecules';
import { AdminService } from '../../../../services';

const ActiveAccounts = props => {
  const location = queryString?.parse(window.location.search);
  const accountId = location?.accountId;
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const [accountsModalOverview, setAccountsModalOverview] = useState(false);
  const [tabValue, setTabValue] = useState('1');
  const [onBoardedAccounts, setOnboardedAccounts] = useState(null);
  const [otherBmAcDetails, setOtherBmAcDetails] = useState(null);
  const [usersDetails, setUsersDetails] = useState(null);
  const { message, setMessage } = useContext(ToasterContext);
  const [toaster, setToaster] = useState(false);
  const [selecetedLimit, setSelectedLimit] = useState(10);

  const [show, showstyle] = useState('');
  const [searchItem, setSearchItem] = useState('');

  const handleBackClick = () => {
    document.body.style.overflow = 'auto';
    setTimeout(() => {
      props.handleModalBackClick();
    }, 1000);
    setAccountsModalOverview(!accountsModalOverview);
  };

  useEffect(() => {
    getInitialData();
    setAccountsModalOverview(true);
  }, []);

  const getInitialData = () => {
    switch (props?.clickedView) {
      case 1:
        getOnboardedClients(1, '');
        getOtherAccounts(1, '');
        break;

      case 2:
        getClientOnboardAccounts(1, '');
        getClientOtherAccounts(1, '');
        break;

      case 3:
        getBmUsers(1, '');
        break;
    }
  };

  const handleChange = (event, newValue) => {
    onTabsChangeRender(newValue);
    setTabValue(Number(newValue));
  };

  const handleChangeUsers = (event, newValue) => {
    setTabValue(Number(newValue));
  };

  const onTabsChangeRender = newValue => {
    setSearchItem('');
    setSelectedLimit(10)
    switch (props?.clickedView) {
      case 1:
        if (newValue == 1) {
          getOnboardedClients(1, '');
        } else {
          getOtherAccounts(1, '');
        }
        break;
      case 2:
        if (newValue == 1) {
          getClientOnboardAccounts(1, '');
        } else {
          getClientOtherAccounts(1, '');
        }
        break;

      case 3:
        getBmUsers(1, '');
        break;
    }
  };

  async function getOnboardedClients(pageNo, searchKeyword, limit = 10) {
    try {
      const acResponse = await AdminService.getOnboardedAccounts(
        userAccessToken,
        username,
        accountId,
        limit,
        pageNo,
        searchKeyword
      );
      setOnboardedAccounts(acResponse?.data?.data);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  async function getOtherAccounts(pageNo, searchKeyword, limit = 10) {
    if(searchKeyword) {
      let searchedResult = otherBmAcDetails.filter(function (obj) {
        return obj.accountId.toLowerCase().includes(searchKeyword.toLowerCase()) || obj.accountName.toLowerCase().includes(searchKeyword) || obj.onboardingStatus.toLowerCase().includes(searchKeyword.toLowerCase());
    });
    setOtherBmAcDetails([...searchedResult]);
    } else {
      try {
        const otherAcResponse = await AdminService.getOtherAccounts(
          userAccessToken,
          username,
          accountId,
          limit,
          pageNo,
          searchKeyword
        );
        let resonseData = otherAcResponse?.data?.data;
        resonseData.forEach(res => res.checked = false);
        setOtherBmAcDetails([...resonseData]);
      } catch (error) {
        const dataCode = error?.data?.data?.code;
      }
    }
  }

  async function getClientOnboardAccounts(pageNo, searchKeyword, limit = 10) {
    try {
      const otherAcResponse = await AdminService.getClientOnboardAccounts(
        userAccessToken,
        username,
        accountId,
        limit,
        pageNo,
        searchKeyword
      );
      let resonseData = otherAcResponse?.data?.data;
      resonseData.onboardedOwnedAdAccounts = resonseData.onboardedClientAdAccounts;
      setOnboardedAccounts(resonseData);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  async function getClientOtherAccounts(pageNo, searchKeyword, limit = 10) {
    if(searchKeyword) {
      let resultedSearchedData = otherBmAcDetails.filter(function (obj) {
        return obj.accountId.toLowerCase().includes(searchKeyword.toLowerCase()) || obj.accountName.toLowerCase().includes(searchKeyword) || obj.onboardingStatus.toLowerCase().includes(searchKeyword.toLowerCase());
    });
    setOtherBmAcDetails([...resultedSearchedData]);
  } else {
    try {
      const otherAcResponse = await AdminService.getClientOtherAccounts(
        userAccessToken,
        username,
        accountId,
        limit,
        pageNo,
        searchKeyword
      );
      let resonseData = otherAcResponse?.data?.data;
      resonseData.forEach(res => res.checked = false);
      setOtherBmAcDetails([...resonseData]);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }
  }

  async function getBmUsers(pageNo, searchKeyword, limit = 10) {
    try {
      const usersResponse = await AdminService.getBmUsers(
        userAccessToken,
        username,
        accountId,
        limit,
        pageNo,
        searchKeyword
      );
      let resonseData = usersResponse?.data?.data;
      setUsersDetails(resonseData);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  const onChangeLimit = (pageNo, searchItem, limit) => {
    setSelectedLimit(limit);
    commonChangeLimit(1, searchItem, limit);
  };

  const commonChangeLimit = (pageNo, searchItem, limit = 10) => {
    switch (props?.clickedView) {
      case 1:
        if (tabValue == '1') {
          getOnboardedClients(pageNo, searchItem, limit);
        } else {
          getOtherAccounts(pageNo, searchItem, limit);
        }
        break;
      case 2:
        if (tabValue == '1') {
          getClientOnboardAccounts(pageNo, searchItem, limit);
        } else {
          getClientOtherAccounts(pageNo, searchItem, limit);
        }
        break;

      case 3:
        getBmUsers(pageNo, searchItem, limit);
        break;
    }
  };

  const onPageChange = (page, searchItem, limit) => {
    setSelectedLimit(limit)
    commonChangeLimit(page, searchItem, limit);
  };

  const getLabelName = () => {
    return props?.clickedView == 1
      ? t('admin.active.owned.acc')
      : props?.clickedView == 2
      ? t('admin.bm.details.active.client')
      : t('admin.tab.users');
  };

  const handleSuccessAdccounts = (isSuccess) => {
    if(isSuccess) {
      setMessage({message: t('admin.add.account.success'), isError: false});
      setToaster(true);
      clearToaster();
      handleChange(null, 1)
    }
  }

  const clearToaster = () => {
    setTimeout(() => {
      console.log('clear called');
      setToaster(false);
    }, 7000);
  };

  const filterHandler = keyword => {
    if (!keyword.trim()) {
      showstyle('');
      setSearchItem('');
      onChangeLimit(1, '', selecetedLimit)
    } else {
      showstyle('show');
      setSearchItem(keyword);
      onChangeLimit(1, keyword, selecetedLimit)
    }
  };

  return (
    <>
      <div className={`attribute-detail-view-overlay ${accountsModalOverview ? 'show' : 'hide'}`}>
        <div className="attribute-detail-view">
          <div className="attribute-detail-view-buttongroup">
            <button className="return-insights" onClick={() => handleBackClick()}>
              <i className="eva  eva-arrow-ios-back-outline"></i>
              {t('user.buttonText.back')}
            </button>
          </div>
          <div className="import-campaign-cta">
            <div className="accounts_header">{getLabelName()}</div>
          </div>
          <div className="listing-container optimisation">
          <div className="sticky-toaster">
        {toaster ? (
          <div className="report-toaster report-toaster-pos">
            {!message.isError && (
              <span>
                <i className="eva eva-checkmark-outline"></i>
              </span>
            )}
            {message.isError && (
              <div className="icon-error">
                <i className="eva eva-close-outline"></i>
              </div>
            )}
            {message?.message}
          </div>
        ) : (
          ''
        )}
      </div>
      <div className="search-section-container search_onboarded">
        <h3></h3>
        <div className="search-field search_onboarded_icon">
          <i className="eva eva-search-outline search-icon"></i>
          <input
            type="text"
            name="search"
            placeholder={props?.clickedView === 3 ? t('serach.email.name'):t('admin.details.search')}
            onChange={e => filterHandler(e.target.value, e)}
            value={searchItem}
            autoComplete="off"
          />
          <button type="button" className={`clear-btn ${show}`} onClick={e => filterHandler('')}>
            <i className="eva eva-close-outline clear-icon"></i>
          </button>
        </div>
      </div>
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={tabValue.toString()}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  {props?.clickedView === 3 && (
                    <TabList
                      onChange={handleChangeUsers}
                      aria-label={t('insights.report.list.heading')}
                    >
                      <Tab
                        label={
                          <React.Fragment>
                            <span className="text">{t('admin.tab.users')} </span>
                            <span>({usersDetails?.pagination?.totalRecords})</span>
                          </React.Fragment>
                        }
                        value="1"
                      />
                    </TabList>
                  )}
                  {props?.clickedView !== 3 && (
                    <TabList onChange={handleChange} aria-label={t('insights.report.list.heading')}>
                      <Tab
                        label={
                          <React.Fragment>
                            <span className="text">{t('admin.tab.onboarded')} </span>
                            <span>({onBoardedAccounts?.pagination?.totalRecords})</span>
                          </React.Fragment>
                        }
                        value="1"
                      />
                      <Tab
                        label={
                          <React.Fragment>
                            <span className="text">{t('admin.tab.other.acc')} </span>
                            <span>({otherBmAcDetails?.length})</span>
                          </React.Fragment>
                        }
                        value="2"
                      />
                    </TabList>
                  )}
                </Box>
                {onBoardedAccounts && (
                  <TabPanel value="1">
                    {' '}
                    <OnboardedAccounts
                      accounts={onBoardedAccounts}
                      changeLimit={onChangeLimit}
                      changePage={onPageChange}
                    />
                  </TabPanel>
                )}
                {otherBmAcDetails && (
                  <TabPanel value="2">
                    <OtherBMAccounts accounts={otherBmAcDetails} accountId={accountId} handleSuccessAdccounts={handleSuccessAdccounts}/>
                  </TabPanel>
                )}

                {usersDetails && (
                  <TabPanel value="1">
                    <UsersList
                      accounts={usersDetails}
                      changeLimit={onChangeLimit}
                      changePage={onPageChange}
                      accountId={accountId}
                    />
                  </TabPanel>
                )}
              </TabContext>
            </Box>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActiveAccounts;
